'use strict';
(function(angular) {
  angular.module('fetchtv.Directives')
    .directive('ftScrollTop', function() {
      return {
        restrict: 'E',
        template: '<script type="text/javascript">window.scrollTo(0, 0);document.body.scrollTop = 0;</script>'
      };
    });
})(angular);

